export default __webpack_public_path__ + "static/media/comm-asl-664x830.60e5eeb6.jpg";